module.exports = __webpack_public_path__ + "img/custom_img2.d611f8f8.png";